enum APPEARANCE {
  highlight = 'highlight',
  outline = 'outline',
  ghost = 'ghost',
}

export default APPEARANCE;
